export function PulsoMark({ className }: { className?: string }) {
	return (
		<svg viewBox="0 0 24 24" aria-hidden="true" className={className} fill="currentColor">
			<path d="M12 5.15C9.55 2.44 5.11 3.2 3.72 6.52c-.88 2.1-.35 4.54.98 6.48h3.67c.7 0 1.05-.33 1.34-.97l1.08-2.39c.44-.98 1.86-.98 2.3 0l1.08 2.39c.29.64.64.97 1.34.97h3.79c1.33-1.94 1.86-4.38.98-6.48-1.39-3.32-5.83-4.08-8.28-1.37Z" />
			<path d="M19.6 14h-4.09c-1.1 0-1.86-.54-2.31-1.54L12 9.81l-1.2 2.65C10.35 13.46 9.59 14 8.49 14H4.4c1.65 2.35 4.25 4.62 7.6 6.65 3.35-2.03 5.95-4.3 7.6-6.65Z" />
		</svg>
	);
}
